import { Type, Origin } from '~/balance/model/balance.model'

export function getTypeText(type: string) {
  switch (type) {
    case Type.RECHARGE:
      return 'Recarga'
    case Type.INITIAL_RECHARGE:
      return 'Recarga inicial'
    case Type.CANCELLED_RECHARGE:
      return 'Anulación recarga'
    default:
      return '-'
  }
}

export function getOriginText(origin: string) {
  switch (origin) {
    case Origin.TPV:
      return 'TPV'
    case Origin.ATM:
      return 'ATM'
    case Origin.CALL_CENTER:
      return 'Call center'
    case Origin.ONLINE_CHANNEL:
      return 'Canal online'
    case Origin.IVR:
      return 'IVR'
    case Origin.SCRATCH_CARD:
      return 'Tarjeta rasca'
    case Origin.AUTOMATIC:
      return 'Automática'
    default:
      return '-'
  }
}
